import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BASE_API_URL } from '../apiConfig';
import { useTranslation } from 'react-i18next';

const MyMatches = () => {
    const [engagements, setEngagements] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        fetchEngagements();
    }, []);

    const fetchEngagements = async () => {
        const token = localStorage.getItem('token');
        try {
            const res = await fetch(`${BASE_API_URL}/users/me/engagements`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setEngagements(data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleRemoveBooking = async (slotId) => {
        if (!window.confirm(t('remove_booking_ask'))) return;
        const token = localStorage.getItem('token');
        try {
            const res = await fetch(`${BASE_API_URL}/matches/${slotId}/bookings`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                fetchEngagements();
            } else {
                const data = await res.json();
                alert(data.error || "Errore durante la rimozione.");
            }
        } catch (err) {
            console.error(err);
        }
    };

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString(undefined, { weekday: 'short', day: '2-digit', month: 'short' });
    };

    const formatTime = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const sportIcons = {
        football: '⚽',
        volleyball: '🏐',
        padel: '🎾',
        basketball: '🏀',
        tennis: '🎾',
        waterpolo: '🤽',
        rugby: '🏉'
    };

    const sportLabels = {
        football: t('football'),
        volleyball: t('volleyball'),
        padel: t('padel'),
        basketball: t('basketball'),
        tennis: t('tennis'),
        waterpolo: t('waterpolo'),
        rugby: t('rugby')
    };

    if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>{t('loading_matches')}</div>;

    return (
        <div className="my-matches-page">
            <h1 className="page-title">{engagements.length > 0 ? t('my_upcoming_matches') : t('my_matches')}</h1>

            {engagements.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-icon">⚽</div>
                    <p>{t('no_upcoming_matches')}</p>
                    <Link to="/" className="primary-btn" style={{ marginTop: '20px', display: 'inline-flex' }}>{t('start_free')}</Link>
                </div>
            ) : (
                <div className="engagements-list">
                    {engagements.map(eng => (
                        <div key={eng.id} className={`engagement-card ${eng.is_confirmed ? 'confirmed' : 'voting'}`}>
                            <div className="engagement-main">
                                <Link to={`/league/${eng.league_id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <div className="engagement-league" style={{ display: 'flex', alignItems: 'center' }}>
                                        <strong>{eng.league_name}</strong>
                                        <span
                                            className={`sport-badge badge-${eng.sport}`}
                                            style={{ position: 'relative', top: 'auto', right: 'auto', margin: '0 0 0 10px', display: 'flex', alignItems: 'center', gap: '4px' }}
                                        >
                                            {sportIcons[eng.sport] || '🏆'} {(sportLabels[eng.sport] || eng.sport).toUpperCase()}
                                        </span>
                                    </div>
                                    <div className="engagement-location">📍 {eng.location}</div>
                                </Link>

                                {eng.address && (
                                    <div className="engagement-address">
                                        <a
                                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(eng.address)}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="location-link"
                                            style={{ fontSize: '0.85rem' }}
                                        >
                                            {eng.address}
                                        </a>
                                    </div>
                                )}

                                {eng.price > 0 && (
                                    <div className="engagement-price" style={{ fontSize: '0.9rem', color: '#555', marginTop: '5px' }}>
                                        💸 {t('per_person')}: <strong>€{(eng.price / (eng.max_players || 10)).toFixed(2)}</strong>
                                    </div>
                                )}

                                {eng.is_confirmed ? (
                                    eng.user_team ? (
                                        <span className="status-badge status-confirmed">✓ {t('match_confirmed').toUpperCase()}</span>
                                    ) : (
                                        <span className="status-badge" style={{ background: '#fff3e0', color: '#e65100' }}>⏳ {t('waitlist').toUpperCase()}</span>
                                    )
                                ) : (
                                    <span className="status-badge status-voting">🗳️ {t('voting').toUpperCase()}</span>
                                )}
                                <div style={{ marginTop: '10px' }}>
                                    <button 
                                        onClick={() => handleRemoveBooking(eng.id)}
                                        className="secondary-btn"
                                        style={{ padding: '4px 8px', fontSize: '0.75rem', color: '#d32f2f', border: '1px solid #d32f2f' }}
                                    >
                                        {t('remove_availability')}
                                    </button>
                                </div>
                            </div>

                            <div className="engagement-time">
                                <div className="time-date">{formatDate(eng.start_time)}</div>
                                <div className="time-hour">{formatTime(eng.start_time)}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MyMatches;
